module.exports = __webpack_public_path__ + "img/85ne.55c62993.svg";